import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const VisitsCalendarPage = lazy(() => import('@pages/visitsCalendar/VisitsCalendarPage'));

// Route Components
const VisitsCalendarRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('visits-calendar-page-title')}>
        <VisitsCalendarPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  VisitsCalendarRoute,
};
